var _defs, _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2315",
    "data-name": "Group 2315",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40.064,
    height: 24.582,
    viewBox: "0 0 40.064 24.582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11758",
    "data-name": "Path 11758",
    d: "M5.013.389a12.251,12.251,0,0,1,4.54,9.53,12.251,12.251,0,0,1-4.54,9.53,12.273,12.273,0,0,1,0-19.06Z",
    transform: "translate(-0.474 -0.389)",
    clipRule: "evenodd"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "_289506944",
    cx: 12.291,
    cy: 12.291,
    r: 12.291,
    fill: "#ff6041"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "_289506128",
    cx: 12.291,
    cy: 12.291,
    r: 12.291,
    transform: "translate(15.482)",
    fill: "#ffd941"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2258",
    "data-name": "Group 2258",
    transform: "translate(15.513 2.781)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2257",
    "data-name": "Group 2257",
    transform: "translate(-2.276 2.419)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2256",
    "data-name": "Group 2256"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_213036096",
    d: "M.435.43H15.09v1.6H.435Z",
    transform: "translate(-0.435 -0.43)",
    fill: "#ff6041",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_213035640",
    d: "M.435.483H15.09v1.6H.435Z",
    transform: "translate(-0.435 2.649)",
    fill: "#ff6041",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_213037800",
    d: "M.435.537H15.09v1.6H.435Z",
    transform: "translate(-0.435 5.786)",
    fill: "#ff6041",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_213037584",
    d: "M.435.59H15.09v1.6H.435Z",
    transform: "translate(-0.435 8.865)",
    fill: "#ff6041",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_213037344",
    d: "M.435.643H15.09v1.6H.435Z",
    transform: "translate(-0.435 11.943)",
    fill: "#ff6041",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/card_icon.94d26ba8fe3b822dd32e148d9e9f1308.svg";
export { ForwardRef as ReactComponent };